export const GET_CONCEPTS = 'GET_CONCEPTS'
export const GET_CONCEPTS_SUCCESS = 'GET_CONCEPTS_SUCCESS'
export const GET_CONCEPTS_FAILED = 'GET_CONCEPTS_FAILED'

export const GET_CONCEPT = 'GET_CONCEPT'
export const GET_CONCEPT_SUCCESS = 'GET_CONCEPT_SUCCESS'
export const GET_CONCEPT_FAILED = 'GET_CONCEPT_FAILED'

export const CREATE_CONCEPT = 'CREATE_CONCEPT'
export const CREATE_CONCEPT_SUCCESS = 'CREATE_CONCEPT_SUCCESS'
export const CREATE_CONCEPT_FAILED = 'CREATE_CONCEPT_FAILED'

export const UPDATE_CONCEPT = 'UPDATE_CONCEPT'
export const UPDATE_CONCEPT_SUCCESS = 'UPDATE_CONCEPT_SUCCESS'
export const UPDATE_CONCEPT_FAILED = 'UPDATE_CONCEPT_FAILED'

export const DELETE_CONCEPT = 'DELETE_CONCEPT'
export const DELETE_CONCEPT_SUCCESS = 'DELETE_CONCEPT_SUCCESS'
export const DELETE_CONCEPTS_FAILED = 'DELETE_CONCEPTS_FAILED'

export const GET_SHOP_CONCEPTS = 'GET_SHOP_CONCEPTS'
export const GET_SHOP_CONCEPTS_SUCCESS = 'GET_SHOP_CONCEPTS_SUCCESS'
export const GET_SHOP_CONCEPTS_FAILED = 'GET_SHOP_CONCEPTS_FAILED'

export const CREATE_SHOP_CONCEPT = 'CREATE_SHOP_CONCEPT'
export const CREATE_SHOP_CONCEPT_SUCCESS = 'CREATE_SHOP_CONCEPT_SUCCESS'
export const CREATE_SHOP_CONCEPT_FAILED = 'CREATE_SHOP_CONCEPT_FAILED'

export const UPDATE_SHOP_CONCEPT = 'UPDATE_SHOP_CONCEPT'
export const UPDATE_SHOP_CONCEPT_SUCCESS = 'UPDATE_SHOP_CONCEPT_SUCCESS'
export const UPDATE_SHOP_CONCEPT_FAILED = 'UPDATE_SHOP_CONCEPT_FAILED'

export const GET_CONCEPT_PARTICIPANTS = 'GET_CONCEPT_PARTICIPANTS'
export const GET_CONCEPT_PARTICIPANTS_SUCCESS = 'GET_CONCEPT_PARTICIPANTS_SUCCESS'
export const GET_CONCEPT_PARTICIPANTS_FAILED = 'GET_CONCEPT_PARTICIPANTS_FAILED'
